// components/whatsapp/WhatsAppIntakeTrigger.tsx
'use client';

/**
 * Trigger genérico del asistente de fechas (W2). Permite que componentes
 * server (BuildingFinalCTA, BuildingReservaDirecta) abran el intake sin
 * convertirse a client: renderiza un <button> con las clases del CTA
 * original + el sheet. El cta_click_whatsapp lo emite el sheet al salir.
 */

import { useState } from 'react';
import WhatsAppIntakeSheet, {
  type WhatsAppIntakeContext,
} from './WhatsAppIntakeSheet';

interface Props {
  context: WhatsAppIntakeContext;
  className?: string;
  ariaLabel?: string;
  dataCtaPosition?: string;
  children: React.ReactNode;
}

export default function WhatsAppIntakeTrigger({
  context,
  className,
  ariaLabel,
  dataCtaPosition,
  children,
}: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={ariaLabel}
        data-cta-position={dataCtaPosition}
        className={className}
      >
        {children}
      </button>
      <WhatsAppIntakeSheet open={open} onClose={() => setOpen(false)} context={context} />
    </>
  );
}
